import { NewTag } from '../../../../components/NewTag';
import type { AdNetwork } from '../../../../domain/opportunity';
import { formatWithSuffix } from '../../../../services/numberFormat';

import { ChangeValue } from './ChangeValue';
import { StyledAdNetworksChange, StyledAdNetworksName, StyledAdNetworksVisits } from './styles';

export const AdNetworksTableRow: React.FC<{ item: AdNetwork }> = ({ item }) => {
  const { name, visits, change, isNew } = item;

  return (
    <>
      <StyledAdNetworksName>
        {name}
        {isNew ? <NewTag /> : null}
      </StyledAdNetworksName>
      <StyledAdNetworksVisits>{formatWithSuffix(visits)}</StyledAdNetworksVisits>
      <StyledAdNetworksChange>
        <ChangeValue change={change} />
      </StyledAdNetworksChange>
    </>
  );
};
